import { QuotePhasesService } from "@common/client"
import { makeAxiosMutation } from "../utils"
import { quoteKey } from "./quote"

export const useCreateQuotePhaseMutation = makeAxiosMutation({
  serviceCall: QuotePhasesService.createPhase,
  invalidates: (params) => [quoteKey(params.quote_id)],
})

export const useUpdateQuotePhaseMutation = makeAxiosMutation({
  serviceCall: QuotePhasesService.updatePhase,
  invalidates: (params) => [quoteKey(params.quote_id)],
})

export const useReorderQuotePhasesMutation = makeAxiosMutation({
  serviceCall: QuotePhasesService.reorderPhases,
  invalidates: (params) => [quoteKey(params.quote_id)],
})

export const useDeleteQuotePhaseMutation = makeAxiosMutation({
  serviceCall: QuotePhasesService.deletePhase,
  invalidates: (params) => [quoteKey(params.quote_id)],
})
